import * as Icons from "lucide-react";

const tones = {
  navy:  { bg: "bg-navy-700", text: "text-white" },
  gold:  { bg: "bg-gold-500", text: "text-navy-900" },
  emerald:{ bg: "bg-emerald-500", text: "text-white" },
  rose:  { bg: "bg-rose-500", text: "text-white" },
  sky:   { bg: "bg-sky-500", text: "text-white" },
  violet:{ bg: "bg-violet-500", text: "text-white" },
  amber: { bg: "bg-amber-500", text: "text-white" },
  slate: { bg: "bg-slate-700", text: "text-white" },
};

export const StatCard = ({ label, value, icon = "Activity", tone = "navy", hint, testId }) => {
  const Icon = Icons[icon] || Icons.Activity;
  const t = tones[tone] || tones.navy;
  return (
    <div className="bms-stat-card p-5" data-testid={testId}>
      <div className="flex items-start justify-between">
        <div>
          <p className="text-xs font-semibold uppercase tracking-wider text-slate-500">{label}</p>
          <p className="font-display text-2xl md:text-3xl font-bold text-slate-900 mt-2">{value}</p>
          {hint && <p className="text-xs text-slate-500 mt-1">{hint}</p>}
        </div>
        <div className={`h-11 w-11 rounded-xl flex items-center justify-center ${t.bg} ${t.text}`}>
          <Icon className="h-5 w-5" />
        </div>
      </div>
    </div>
  );
};
